var curChapter;
var saveData = {};
var chartProgressRecorded = {};
$(document).ready(function () {
	initCourse();
	documentSetup();
	chartProgress();
	if (!globalVar.devMode && (lmsConnected || globalVar.scormSettings.useLocal)) {
		jumpToSlide(saveData.bookmark);
	}
	// Elements to inject
	var mySVGsToInject = document.querySelectorAll('img.inject-me');
	// Do the injection. keep last!!!
	SVGInjector(mySVGsToInject);
});

function firstTimeSetup() {
	//first and only execution of code, when the course starts first time gives all slides a number and sets defaults for user attempts and trys
	var keys = Object.keys(slides);

	handleMasterAndGroups(slides);
	if (globalVar.earnCoins === true) {
		if (!saveData.coinScore) saveData.coinScore = {};
	}

	keys.forEach(function (key, idx) {
		var type = slides[key].type;
		var slideObj = slides[key];
		var slideSettings = slideObj[type];

		// give slidenumber used for bookmarking
		if (slideObj.slideNumber === undefined) {
			slideObj.slideNumber = idx + 1;
		}
		// set user attempts and trys if not defined

		if (slideSettings !== undefined) {
			if (slideSettings.userAttempts === undefined) slideSettings.userAttempts = 0;
			if (slideSettings.trys === undefined) slideSettings.trys = 0;
		} else {
			slideSettings = {
				userAttempts: 0,
				trys: 0
			};
		}

		// Create the object sent to the LMS to persist slide completion
		// set include to false on a slide in order to exclude it from the course progression
		if (slideObj.include === undefined) {
			slideObj.include = true;
		}

		if (slideObj.include) {
			var path = slideObj.completionPath;

			if (!saveData.slideCompletion) saveData.slideCompletion = {};

			var slideCompletion = saveData.slideCompletion;

			if (path) {
				if (Array.isArray(path)) {
					path.forEach(function (p, i) {
						if (!slideCompletion[p]) slideCompletion[p] = {};
						if (!slideCompletion[p][key]) slideCompletion[p][key] = 0;
					});
				} else {
					if (!slideCompletion[path]) slideCompletion[path] = {};
					if (!slideCompletion[path][key]) slideCompletion[path][key] = 0;
				}
			} else {
				if (!slideCompletion.mainPath) slideCompletion.mainPath = {};
				if (!slideCompletion.mainPath[key]) slideCompletion.mainPath[key] = 0;
			}
		}

		if (globalVar.earnCoins === true) {
			if (!saveData.coinScore[key]) saveData.coinScore[key] = {};
			if (slideObj.coinSettings === undefined) {
				slideObj.coinSettings = {};
				slideObj.coinSettings.include = true;
			}
		}
	});

	window.leaderlines = {};
}

function documentSetup() {
	initPreloader();
	setGlobalVars($('section' + '.present')[0].id);
	firstTimeSetup();
	initAudio();
	$('aside').remove();
	initNavigation();
	initSideMenu();

	for (key in slides) {
		if (slides[key].type === 'video') {
			globalVar.videoSeen[key] = false;
		}
	}
	if (globalVar.devMode) {
		devMode();
	}

	if ($('#si-progress-meter').length != 0) {
		chartInitiate();
	}
	initFeedbacks();
	initQuiz();
	initMenu();
	functionCalls();
	randomizeQuestionSlides();

	Reveal.addEventListener('slidechanged', function (e) {
		$('#si-nav-container').removeClass('vjs-fade-out');
		setGlobalVars(e.currentSlide.id);

		closeSideMenu();

		slideAction(e.previousSlide.id, 'onExitAction');
		e.previousSlide.id;
		functionCalls();
	});

	//set font sizes
	var fontSize = $('.slides').width() / globalVar.fontSizeFactor;
	$('html').css('font-size', fontSize);

	$(window).resize(function () {
		setTimeout(function () {
			var fontSize = $('.slides').width() / globalVar.fontSizeFactor;
			$('html').css('font-size', fontSize);
		}, 1);
	});

	$('img').on('dragstart', function (event) {
		event.preventDefault();
	});
}

function setGlobalVars(slideID) {
	// DEPRECIATED
	globalVar.curSlide = slideID;
	// DEPRECIATED
	globalVar.$curSlide = $('#' + slideID);

	globalVar.slide = getSlideHelpers(slideID);
}

function actionsOnEverySlideEnter() {
	//whatever you want to execute on every slide change
}

//execute whatever is inside onEnterAction, sets visited to true
function onEnterAction(id) {
	if (slides[id].visited === undefined) {
		slides[id].visited = false;
	}

	$('section:not(.present)').each(function (idx, slide) {
		$('body').removeClass(slide.id);
		if (slides[slide.id].styleLabel) $('body').removeClass(slides[slide.id].styleLabel);
	});

	$('body').addClass(id);
	if (slides[id].styleLabel) $('body').addClass(slides[id].styleLabel);

	$(document.activeElement).blur();
	if (siAudio[globalVar.curSlide].onEnter) {
		if (siAudio.sfx.click.playing()) {
			siAudio.sfx.click.once('end', function () {
				Howler.stop();
				siAudio[globalVar.curSlide].onEnter.play();
			});
		} else {
			Howler.stop();
			siAudio[globalVar.curSlide].onEnter.play();
		}
	} else {
		if (siAudio.sfx.click.playing()) {
			siAudio.sfx.click.once('end', function () {
				Howler.stop();
			});
		} else {
			Howler.stop();
		}
	}

	setTimeout(function () {
		slideAction(id, 'onEnterAction');

		slides[id].visited = true;
	}, 10);
	if (lmsConnected && slides[id].slideNumber !== 1) {
		setTimeout(function () {
			saveLMS();
		}, 1000);
	}
	if (globalVar.scormSettings.useLocal && slides[id].slideNumber !== 1) {
		saveProgressLocally();
	}
}

//Order of calling the functions to generate the current slide
function functionCalls() {
	$('body').off();

	setGlobalVars($('.slides > .present')[0].id);

	var slide = globalVar.slide;

	onEnterAction(globalVar.curSlide);
	actionsOnEverySlideEnter();
	showNavElements();
	elementsFadingOnSlide();

	switch (slide.data.type) {
		case 'menu':
			menuFunctions();
			break;
		case 'dnd':
			dndFunction();
			break;
		case 'sort':
			sortFunctions();
			break;
		case 'hotspot':
			hotspotFunctions();
			break;
		case 'form':
			formFunctions();
			break;
		case 'quiz':
			quizFunction();
			break;
		case 'scratch':
			scratchFunctions(slide);
			break;
		case 'video':
			videoCheck();
			break;
		default:
			break;
	}

	if ($('#si-progress-meter').length != 0) {
		chartProgress();
	}

	// IE9 Bugfix
	setTimeout(function () {
		$('section.future').css('display', 'none');
		$('section.past').css('display', 'none');
	}, 55);
}

////////////*Feature: Question Check ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// This function contains the main logic in determining if a question is right or wrong
// It determines the question type, runs the logic for that type and returns a boolean
// This boolean, called bol,  is fed as an argument to handleAnswer(bol) which is responsible for handling feedback responses

// To add unique logic for a custom type, extend the main switch statement, assign true or false to bol, then 'break'
function checkQuestion(type) {
	var bol = true;
	var bol2;
	switch (type) {
		case 'quiz':
			var correctAnswers = slides[globalVar.curSlide].quiz.answers;
			var selectedAnswers = {};
			var choices = $('#' + globalVar.curSlide + ' .si-quiz-answer');
			choices.each(function (idx, choice) {
				var id = $(choice).attr('id') || 'wrong' + idx;
				if ($(choice).hasClass('si-quiz-selected')) {
					selectedAnswers[id] = 1;
				} else {
					selectedAnswers[id] = 0;
				}
				if (!correctAnswers[id]) {
					correctAnswers[id] = 0;
				}
			});
			for (answer in selectedAnswers) {
				if (correctAnswers[answer] !== selectedAnswers[answer]) {
					bol = false;
					return bol;
				} else if (slides[globalVar.curSlide].coinSettings.earnByAnswerChoice) {
					if (selectedAnswers[answer] === 1) {
						addCoinForAnswer(answer);
					}
				}
			}
			if (!bol) {
				return bol;
			}
			break;
		case 'hotspot':
			bol = checkHotspot();
			if (!bol) return;

			break;
		case 'form':
			bol = checkForm();
			if (!bol) return;
			break;
		case 'dnd':
			bol = checkDnd();
			break;
		case 'sort':
			bol = true;
			var listArray = Object.keys(slides[globalVar.curSlide][type].sortables);
			var answerArray = [];
			listArray.forEach(function (list) {
				answerArray.push(slides[globalVar.curSlide][type].sortables[list].answer);
			});

			// check that answers have been provided for all sortable lists before proceeding
			if (listArray.length !== answerArray.length) {
				bol = false;
				return bol;
			}

			listArray.forEach(function (listId, idx) {
				var possibleAnswer = $('#' + listId).sortable('toArray');

				// Incorrect if the amount of items in the checked sortable does not match the amount of answers provided in the answer key
				if (possibleAnswer.length !== answerArray[idx].length) {
					bol = false;
					return bol;
				}

				// Excutes if unordered key is set to false or if key is absent
				// This branch is only correct if the submitted answer matches the answer key in both content AND order
				if (
					slides[globalVar.curSlide][type].unordered === false ||
					slides[globalVar.curSlide][type].unordered === undefined
				) {
					possibleAnswer.forEach(function (answer, idx2) {
						if (answer !== answerArray[idx][idx2]) {
							bol = false;
							return bol;
						}
					});
					// Executes if unordered key is set to true.
					// This branch is correct if the submitted answer matches the answer key in content only. Order is irrelevant
				} else {
					possibleAnswer.forEach(function (answer) {
						if (
							!answerArray[idx].some(function (el) {
								return el === answer;
							})
						) {
							bol = false;
							return bol;
						}
					});
				}
			});
			break;
		default:
			bol = false;
			break;
	} //end switch
	return bol;
} //checkQuestion
//////////*Feature:Shuffled Slides/////////////////////////////////////////////////////////////////////////////////////////////////////////////

function jumpToShuffledSlide(part) {
	var n = globalVar.shuffledSlides[part].pointer;
	if (n < globalVar.shuffledSlides[part].slides.length) {
		if (n == null) {
			//first time call
			n = 0;
		}
		jumpToSlide(globalVar.shuffledSlides[part].slides[n]);
		n++;
		globalVar.shuffledSlides[part].pointer = n;
	}
}

function resetShuffledSlide(part) {
	globalVar.shuffledSlides[part].pointer = null;
}

/////////*Feature:Randomize Questions//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function randomizeQuestionSlides() {
	if (globalVar.randomizeSlides.useRandomize == true) {
		var x = globalVar.randomizeSlides.slides;
		var n = [];
		if (Object.keys(x) != 0) {
			for (key in x) {
				n = [];
				if (x[key][0] < x[key][1]) {
					//1st value must be less than 2nd
					for (var i = x[key][0]; i <= x[key][1]; i++) {
						n.push(i);
					}
					shuffle(n);
					n.push(x[key][2]);
					globalVar.shuffledSlides[key] = {
						slides: n,
						pointer: null
					};
				}
			}
		}
	}
}

////////////*Feature:Fading///////////////////////////////////////////////////////////////////////////////////////////////////////////

function elementsFadingOnSlide() {
	if ($('#' + globalVar.curSlide + ' [data-fadeInOrder]').length != 0) {
		var ary = [];
		$('#' + globalVar.curSlide + ' [data-fadeInOrder]').each(function () {
			$(this).css('opacity', '0');
			$(this).css('display', 'none');
			$(this).hide();
			var temp = [];
			var str = $(this).data('fadeinorder');
			temp[0] = str;
			temp[1] = $(this)[0];
			ary.push(temp);
		});
		ary.sort(sortArrayMatrixFunction);
		for (var i = 0; i < ary.length; i++) {
			elementsFadeIn(ary[i][1], ary[i][0]);
		}
	}

	if ($('#' + globalVar.curSlide + ' [data-fadeoutorder]').length != 0) {
		var ary = [];
		$('#' + globalVar.curSlide + ' [data-fadeoutorder]').each(function () {
			$(this).css('opacity', '1');
			$(this).css('display', 'block');
			$(this).show();
			var temp = [];
			var str = $(this).data('fadeoutorder');
			temp[0] = str;
			temp[1] = $(this)[0];
			ary.push(temp);
		});
		ary.sort(sortArrayMatrixFunction);
		for (var i = 0; i < ary.length; i++) {
			elementsFadeOut(ary[i][1], ary[i][0]);
		}
	}
}

function elementsFadeIn(el, x) {
	setTimeout(function () {
		$(el).fadeTo('fast', 1);
	}, x);
}

function elementsFadeOut(el, x) {
	setTimeout(function () {
		$(el).fadeTo('fast', 0);
	}, x);
}

// ary.sort(sortArrayMatrixFunction); must be ary=[[4,xx],[2,xx],[1,xx]]
function sortArrayMatrixFunction(a, b) {
	if (a[0] === b[0]) {
		return 0;
	} else {
		return a[0] < b[0] ? -1 : 1;
	}
}

////////////*Feature:Miscellaneous///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//shuffle an array, returns shuffled array
// used in slide randomizer and mcq/scq randomizer
function shuffle(array) {
	var currentIndex = array.length,
		temporaryValue,
		randomIndex;
	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
}

//adds equals/checks to see if arrays equal each other
Array.prototype.equals = function (array) {
	// if the other array is a falsy value, return
	if (!array) return false;

	// compare lengths - can save a lot of time
	if (this.length != array.length) return false;

	for (var i = 0, l = this.length; i < l; i++) {
		// Check if we have nested arrays
		if (this[i] instanceof Array && array[i] instanceof Array) {
			// recurse into the nested arrays
			if (!this[i].equals(array[i])) return false;
		} else if (this[i] != array[i]) {
			// Warning - two different object instances will never be equal: {x:20} != {x:20}
			return false;
		}
	}
	return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, 'equals', {
	enumerable: false
});

function handleMasterAndGroups(slides) {
	var keys = Object.keys(slides);

	keys.forEach(function (slideID, idx) {
		var slideObj = slides[slideID];

		var hasMaster = typeof masterSlide !== 'undefined';

		var groups = Array.isArray(slideObj.groups) ? slideObj.groups : [slideObj.groups];
		var hasGroup = groups[0] !== null && groups[0] !== undefined;

		if (hasGroup) {
			groups.reverse().forEach(function (group) {
				for (var setting in group) {
					copySettingFromTo(setting, group, slideObj, slideID);
				}
			});
			groups.reverse();
		}
		if (hasMaster) {
			for (var setting in masterSlide) {
				copySettingFromTo(setting, masterSlide, slideObj, slideID);
			}
		}
	});
}

function copySettingFromTo(setting, fromObj, toObj, slideID, calledRecursively) {
	var isActionFunction = setting.indexOf('Action') >= 0 || setting.indexOf('customSubmit') >= 0;

	if (isActionFunction) return;
	// if(typeof fromObj[setting] !== 'function' &)
	var isTemplateFunction = typeof fromObj[setting] === 'function' && !calledRecursively;
	var fromSetting = isTemplateFunction ? fromObj[setting](getSlideHelpers(slideID)) : fromObj[setting];

	var notPreviouslySet = toObj[setting] === undefined;
	var notObject = typeof fromSetting !== 'object';

	if (notPreviouslySet) return (toObj[setting] = fromSetting);
	else if (Array.isArray(fromSetting)) return (toObj[setting] = fromSetting.concat(toObj[setting]));
	else if (notObject) return;

	for (var key in fromSetting) {
		copySettingFromTo(key, fromSetting, toObj[setting], slideID, true);
	}
}
function changeGroupSetting(group, setting, newValue) {}
